const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }

export default [
  {
    path: '/notificacoes',
    component: () => import('@/modules/usuarios/views/pages/NotificationSettings.vue'),
    meta: {
      title: 'Notificações',
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Notificações',
          pathName: null,
        },
      ],
    },
  },
  {
    path: '/perfil',
    component: () => import('@/modules/usuarios/views/pages/NotificationSettings.vue'),
    meta: {
      title: 'Notificações',
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Notificações',
          pathName: null,
        },
      ],
    },
  },
  {
    path: '/v3/usuarios',
    component: () => import('@/views/BaseRoutingComponent.vue'),
    children: [
      {
        path: '',
        component: () => import('@/modules/usuarios/views/pages/Users.vue'),
        meta: {
          title: 'Usuários',
          requiredUserPermissions: ['usuarios/editar'],
          allowOnlyMercapromo: true,
          breadcrumbs: [
            breadcrumbsHome,
            {
              name: 'Usuários',
              pathName: null,
            },
          ],
        },
      },
      {
        path: 'permissionamento/:email',
        component: () => import('@/modules/usuarios/views/pages/Permissions.vue'),
        meta: {
          title: 'Usuários',
          requiredUserPermissions: ['usuarios/permissionamento'],
          allowOnlyMercapromo: true,
          breadcrumbs: [
            breadcrumbsHome,
            {
              name: 'Usuários',
              pathName: '/v3/usuarios',
            },
            {
              name: 'Permissionamento',
              pathName: null,
            },
          ],
        },
      },
    ],
  },
]
